<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'dialogs.productSubscription.tenantRelationDialogTitle' | translate }}</h2>
            <button
                data-test="B-Close-dialog"
                mat-icon-button
                (click)="dialogRef.close(false)"
                [attr.aria-label]="'common.closeDialogAria' | translate"
            >
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>
        <ng-container *ngIf="loading; else content">
            <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
        </ng-container>

        <ng-template #content>
            <div>
                <div [formGroup]="tenantRelationDatesForm">
                    <form-widget-tenant-relation
                        [parentFormGroup]="tenantRelationDatesForm"
                        [prefilledTenantRelationId]="tenantRelationAssignment?.tenantRelation?.id"
                        [disableConditionCallback]="disableConditionCallback"
                        [givenTenantRelations]="givenTenantRelations"
                        [personOrCompanyName]="personOrCompanyName"
                        [slimmedView]="true"
                        [multipleSelectable]="multipleSelectable"
                    ></form-widget-tenant-relation>

                    <ng-container *ngIf="priceRuleRequirements.requires(DynamicPriceRulesEntityId.Boat)">
                        <u2b-message type="warning" class="mb-16">
                            <header>Boot erforderlich</header>
                            <p>
                                Mindestens ein Produkt der ausgewählten Beziehung benötigt Boot-Daten
                                für die dynamische Preisberechnung. Bitte wähle ein Boot aus.
                            </p>
                        </u2b-message>

                        <form-widget-boat
                            [appearance]="'outline'"
                            [boatRequired]="true"
                            [slimmedView]="true"
                            [canCreate]="false"
                            [givenBoats]="givenBoats"
                            [boatOwnerName]="personOrCompanyName"
                            [selectBoat]="tenantRelationAssignment?.boat"
                        ></form-widget-boat>
                    </ng-container>

                    <ng-container *ngIf="priceRuleRequirements.requires(DynamicPriceRulesEntityId.Berth)">
                        <u2b-message type="warning" class="mb-16">
                            <header>Liegeplatz erforderlich</header>
                            <p>
                                Mindestens ein Produkt benötigt Liegeplatz-Daten
                                für die dynamische Preisberechnung. Bitte wähle einen Liegeplatz aus.
                            </p>
                        </u2b-message>

                        <form-widget-berth
                            [parentFormGroup]="tenantRelationDatesForm"
                            [selectBerth]="tenantRelationAssignment?.berth"
                            [slimmedView]="true"
                        ></form-widget-berth>
                    </ng-container>

                    <ng-container *ngIf="priceRuleRequirements.requires(DynamicPriceRulesEntityId.WinterStorage)">
                        <u2b-message type="warning" class="mb-16">
                            <header>Lagerplatz erforderlich</header>
                            <p>
                                Mindestens ein Produkt benötigt Lagerplatz-Daten
                                für die dynamische Preisberechnung. Bitte wähle einen Lagerplatz aus.
                            </p>
                        </u2b-message>

                        <form-widget-winter-storage
                            [parentFormGroup]="tenantRelationDatesForm"
                            [appearance]="'outline'"
                            [winterStorageRequired]="true"
                            [slimmedView]="true"
                            [selectWinterStorage]="tenantRelationAssignment?.winterStorage"
                        ></form-widget-winter-storage>
                    </ng-container>

                    <ng-container *ngIf="priceRuleRequirements.requires(DynamicPriceRulesEntityId.Pier)">
                        <u2b-message type="warning" class="mb-16">
                            <header>Steg erforderlich</header>
                            <p>
                                Mindestens ein Produkt benötigt Steg-Daten
                                für die dynamische Preisberechnung. Bitte wähle einen Steg aus.
                            </p>
                        </u2b-message>

                        <form-widget-pier
                            [parentFormGroup]="tenantRelationDatesForm"
                            [appearance]="'outline'"
                            [pierRequired]="true"
                            [slimmedView]="true"
                            [selectPier]="tenantRelationAssignment?.pier"
                        ></form-widget-pier>
                    </ng-container>

                    <ng-container *ngIf="priceRuleRequirements.requires(DynamicPriceRulesEntityId.Season)">
                        <u2b-message type="warning" class="mb-16">
                            <header>Saison erforderlich</header>
                            <p>
                                Mindestens ein Produkt benötigt eine Saison-Zuordnung
                                für die dynamische Preisberechnung. Bitte wähle eine Saison aus.
                            </p>
                        </u2b-message>

                        <form-widget-season
                            [parentFormGroup]="tenantRelationDatesForm"
                            [appearance]="'outline'"
                            [seasonRequired]="true"
                            [slimmedView]="true"
                            [selectSeason]="tenantRelationAssignment?.season"
                        ></form-widget-season>
                    </ng-container>

                    <ng-container *ngIf="priceRuleRequirements.requires(DynamicPriceRulesEntityId.TenantRelation)">
                        <u2b-message type="info" class="mb-16">
                            <header>Abhängigkeit zu anderen Beziehungen</header>
                            <p>
                                Der dynamische Preis wertet die folgende(n) Beziehung(en)
                                der Person bzw. des Unternehmens aus:
                            </p>
                            <ng-container *ngIf="tenantRelationRuleHints.required?.length">
                                <p class="mb-0"><strong>Muss vorhanden sein:</strong></p>
                                <ul>
                                    <li *ngFor="let tr of tenantRelationRuleHints.required">{{ tr.name }}</li>
                                </ul>
                            </ng-container>
                            <ng-container *ngIf="tenantRelationRuleHints.excluded?.length">
                                <p class="mb-0"><strong>Darf nicht vorhanden sein:</strong></p>
                                <ul>
                                    <li *ngFor="let tr of tenantRelationRuleHints.excluded">{{ tr.name }}</li>
                                </ul>
                            </ng-container>
                        </u2b-message>
                    </ng-container>

                    <div fxLayout="column" fxLayoutAlign="start start" class="mb-8">
                        <h2>{{ 'bcmTenantRelations.dateRangeDialog.title' | translate }}</h2>
                        <div>{{ 'bcmTenantRelations.dateRangeDialog.endOpenHint' | translate }}</div>
                    </div>

                    <app-input-date-time formControlName="fromDate">
                        <label>{{ 'dialogs.booking.tenant.labelStart' | translate }}</label>
                    </app-input-date-time>

                    <app-input-date-time formControlName="toDate">
                        <label>{{ 'dialogs.booking.tenant.labelEnd' | translate }}</label>
                    </app-input-date-time>
                </div>

                <!-- Outside the fee gate below: both states disable saving, so they have to explain
                     themselves for a fee-less relation too - its products are loaded as well. -->
                <ng-container *ngIf="productsLoading || productsFailed">
                    <mat-divider class="my-24"></mat-divider>

                    <u2b-message *ngIf="productsLoading" type="info" class="mb-16">
                        <p class="m-0">{{ 'dialogs.tenantRelationData.productsLoading' | translate }}</p>
                    </u2b-message>

                    <u2b-message *ngIf="productsFailed" type="error" class="mb-16">
                        <header>{{ 'dialogs.tenantRelationData.productsFailedHeader' | translate }}</header>
                        <p>{{ 'dialogs.tenantRelationData.productsFailedBody' | translate }}</p>
                        <button mat-stroked-button type="button" (click)="retryProductLoad()">
                            <mat-icon>refresh</mat-icon>
                            {{ 'dialogs.tenantRelationData.productsRetry' | translate }}
                        </button>
                    </u2b-message>
                </ng-container>

                <ng-container *ngIf="hasFeeRelation">
                    <mat-divider *ngIf="!productsLoading && !productsFailed" class="my-24"></mat-divider>

                    <u2b-message *ngIf="products?.length" type="info">
                        <header>{{ 'dialogs.booking.tenant.productsFoundHeader' | translate }}</header>
                        <p>
                            {{ 'dialogs.tenantRelationData.productsFoundBody' | translate }}
                        </p>
                        <ng-container *ngFor="let tenantRelation of selectedTenantRelations">
                            <div>
                                <strong>
                                    {{ tenantRelation.name }}
                                </strong>
                            </div>
                            <ng-container *ngFor="let product of tenantRelation.products">
                                <div>
                                    <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class="pr-16">{{ product.name }}</div>
                                        <div>{{ (product.dynamicPrice?.rulePrice != null ? product.dynamicPrice.rulePrice : product.price) | bcmDynamicCurrency: '1.2-2' }}</div>
                                    </div>
                                    <ul
                                        *ngIf="product.dynamicPrice?.matchingRuleEvaluations?.evaluations?.length"
                                        class="pl-16 m-0"
                                    >
                                        <li *ngFor="let evaluation of product.dynamicPrice.matchingRuleEvaluations.evaluations">
                                            {{ evaluation.conditionEntity }}
                                            {{ evaluation.conditionOperatorText }}
                                            {{ evaluation.requiredValue }}
                                            <span *ngIf="evaluation.givenValue != null"> — {{ evaluation.givenValue }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </ng-container>
                    </u2b-message>

                    <mat-divider class="my-24"></mat-divider>

                    <div [formGroup]="subscriptionForm">
                        <ng-container *hasTenantPermission="BcmTenantPermission.COST_CENTERS">
                            <mat-divider class="my-24"></mat-divider>

                            <h2>{{ 'dialogs.productSubscription.costCentersHeading' | translate }}</h2>

                            <ng-container *ngFor="let product of products; let index = index">
                                <div>
                                    <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
                                        <div class="pr-16">{{ product.name }}</div>

                                        <app-input-cost-centers
                                            [control]="productsCostCenterFormControls[index] | formControl"
                                        ></app-input-cost-centers>
                                    </div>
                                </div>
                            </ng-container>

                            <mat-divider class="my-24"></mat-divider>
                        </ng-container>

                        <div fxLayout="column" fxLayoutAlign="start start" class="mb-8">
                            <br />
                            <strong>
                                {{ 'dialogs.productSubscription.recurringPaymentHeader' | translate }}
                                <ng-container *ngIf="payableOption?.translationKey as pk">
                                    <span style="text-transform: lowercase;"> - {{ pk | translate }} </span>
                                </ng-container>
                            </strong>
                        </div>

                        <h3 [innerHTML]="'dialogs.productSubscription.headlineFirstPositionHtml' | translate"></h3>
                        <app-input-date-time formControlName="periodFromDate">
                            <label>{{ 'dialogs.productSubscription.labelFirstPosition' | translate }}</label>
                        </app-input-date-time>

                        <h3 [innerHTML]="'dialogs.productSubscription.headlineLastPositionHtml' | translate"></h3>
                        <app-input-date-time formControlName="periodToDate">
                            <label>{{ 'dialogs.productSubscription.labelLastPosition' | translate }}</label>
                        </app-input-date-time>

                        <div *ngIf="hasSeasonsPermission" fxLayout="column" fxLayoutAlign="start start" class="mb-8">
                            <h2>{{ 'dialogs.productSubscription.firstServicePeriodHeading' | translate }}</h2>
                            <p>
                                {{ 'dialogs.productSubscription.firstServicePeriodIntro' | translate }}
                                <ng-container *ngIf="payableOption?.translationKey; else other">
                                    <strong style="text-transform: lowercase;">{{ payableOption?.translationKey | translate }}</strong>
                                </ng-container>
                                <ng-template #other>{{ 'dialogs.productSubscription.inSelectedPayableInterval' | translate }}</ng-template>
                                {{ 'dialogs.productSubscription.servicePeriodRegeneratedSuffix' | translate }}
                            </p>
                        </div>

                        <div *ngIf="!hasSeasonsPermission" fxLayout="column" fxLayoutAlign="start start" class="mb-8">
                            <h2>{{ 'dialogs.productSubscription.firstServicePeriodHeading' | translate }}</h2>
                            <u2b-message type="error">
                                <header>{{ 'common.noPermission' | translate }}</header>
                                <p>{{ 'person.invoices.subscriptions.noPermission' | translate }}</p>
                            </u2b-message>
                        </div>
                        <ng-container *ngIf="payableOption?.id === PayableOptionId.Yearly && seasons?.length">
                            <div fxLayout="row" fxLayoutAlign="start start">
                                <mat-form-field appearance="outline" floatLabel="always" fxFlex>
                                    <mat-label>{{ 'dialogs.productSubscription.seasonsMatLabel' | translate }}</mat-label>
                                    <mat-select
                                        data-test="FS-Saisons"
                                        [formControl]="seasonFormControl"
                                        [compareWith]="compareSeasons"
                                    >
                                        <mat-option [value]="null">{{ 'dialogs.productSubscription.noSeasonOption' | translate }}</mat-option>
                                        <mat-option *ngFor="let season of seasons" [value]="season">
                                            {{ season.name }} / {{ season.startDate | dfnsFormat : 'dd.MM.yyyy' }} -
                                            {{ season.endDate | dfnsFormat : 'dd.MM.yyyy' }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </ng-container>

                        <app-input-date-time [readonly]="!hasSeasonsPermission" formControlName="vestingPeriodFrom">
                            <label>{{ 'dialogs.productSubscription.vestingPeriodStart' | translate }}</label>
                        </app-input-date-time>

                        <app-input-date-time [readonly]="!hasSeasonsPermission" formControlName="vestingPeriodUntil">
                            <label>{{ 'dialogs.productSubscription.vestingPeriodEnd' | translate }}</label>
                        </app-input-date-time>

                        <ng-container
                            *ngIf="[PayableOptionId.Monthly, PayableOptionId.HalfYearly, PayableOptionId.QuarterYearly].includes(payableOption?.id)"
                        >
                            <div fxLayout="row" fxLayoutAlign="start start">
                                <mat-checkbox formControlName="lastDayOfMonth">
                                    {{ 'dialogs.productSubscription.lastDayOfMonthCheckbox' | translate }}
                                </mat-checkbox>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-template>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">
        <button
            data-test="B-Abbrechen"
            mat-button
            (click)="dialogRef.close(false)"
            class="save-button mat-primary"
            [attr.aria-label]="'common.cancel' | translate"
        >
            <mat-icon>cancel</mat-icon>
            {{ 'common.cancel' | translate }}
        </button>

        <button
            data-test="B-Speichern"
            mat-flat-button
            [disabled]="productsLoading || productsFailed"
            (click)="save()"
            class="save-button mat-accent"
            [attr.aria-label]="'common.save' | translate"
        >
            <mat-icon>save</mat-icon>
            {{ 'common.save' | translate }}
        </button>
    </div>
</div>
